export const MODULES = {
  SETTINGS: {
    MESSENGERS: {
      FORM_LINKED_CHANNELS: 'FORM_LINKED_CHANNELS',
    },
  },
};
